import React, {useState, useEffect} from "react"
import axios from "axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
    CircularProgress,
    DialogContent,
    Divider,
    FormControl,
    InputAdornment,
    InputLabel,
    ListItemButton,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import {green} from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import ErrorMsg from "../msg/ErrorMsg";
import SuccsMsg from "../msg/SuccsMsg";

const style = {
    width: 300,
    bgcolor: 'background.paper',
    textAlign: 'center',
    maxHeight: '90%',
    overflowY: 'auto',
    transaction: '1s',
};
const Addgoods = ({csrname, csrtel, csraddress, csrid, factor_key, factor_type, setShowaddgood, setChange}) => {
    const [product, setProduct] = useState([]);
    const [search, setSearch] = React.useState("");
    const [unit, setUnit] = React.useState('');
    const [zekhamat, setZekhamat] = React.useState("");
    const [arz, setArz] = React.useState("");
    const [tol, setTol] = React.useState("");
    const [total, setTotal] = React.useState("");
    const [price, setPrice] = React.useState("");
    const [colorcode, setColorcode] = React.useState("");
    const [txtzekhamat, setTxtZekhamat] = React.useState("");
    const [txtarz, setTxtArz] = React.useState("");
    const [txttol, setTxtTol] = React.useState("");
    const [txtcolorcode, setTxtcolorcode] = React.useState("");
    const [productselected, setProductselected] = React.useState();
    const [tileType, setTileType] = useState("");
    const [tT, setTT] = useState([]);
    const [titleproductselected, setTitleproductselected] = React.useState();
    const [showproductlist, setShowproductlist] = React.useState(true);
    const [nextbtn, setNextbtn] = React.useState(false);
    const [addbtn, setAddbtn] = React.useState(false);
    const [open, setOpen] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [loadingProduct, setLoadingProduct] = React.useState(true);
    const [errorMsg , setErrorMsg] = useState("");
    const [succsMsg , setSuccsMsg] = useState("");
    useEffect(() => {
        axios.get("https://app.zhivay.com/api/get_productlist.php")
            .then(respone => {
                setProduct(respone.data);
                setLoadingProduct(false);
            })
            .catch(error => console.log(error));
    }, [null])
    useEffect(() => {
        setLoading(false);
    }, [tT])

    function Send_to_server() {
        let pe = price.replace(/,/g, '');
        const data = {
            title: productselected,
            total: total,
            unit: unit,
            price: pe,
            zekhamat: txtzekhamat,
            arz: txtarz,
            tol: txttol,
            keyid: factor_key,
            cname: csrname,
            ctel: csrtel,
            caddress: csraddress,
            cid: csrid,
            colorcode: colorcode,
            type: factor_type,
            tiletype: tileType,
            token: localStorage.getItem("token")
        };
        axios.post('https://app.zhivay.com/api/insert_factor.php', data, {timeout: 2000})
            .then(respone => {
                if (respone.data.error === false) {
                    setSuccsMsg(respone.data.message);
                    handleClose();
                    setChange(true);
                } else {
                    setLoading(false);
                    setErrorMsg(respone.data.message);
                    if (respone.data.ex_token === true)
                        window.location.href = "/login";
                }
            })
            .catch(error => console.log(error));
        return (data.total);
    }

    function clear() {
        setNextbtn(false);
        setShowproductlist(true);
        setAddbtn(false);
        setTotal("");
        setShowaddgood(false);
    }

    const handleClose = () => {
        if (open === false) {
            clear();

        } else {
            setOpen(false);
            setLoading(false);
        }
        setShowaddgood(false)
    }
    const HandlebtnnextClick = () => {
        setLoading(true);
        const data = {
            productid: productselected
        }
        axios.post('https://app.zhivay.com/api/get_producttype.php', {data})
            .then(respone => {
                setShowproductlist(false);
                setNextbtn(false);
                setAddbtn(true);
                let productt = respone.data[0];
                if (productt["pe_height"] === "1")
                    setZekhamat(true);
                else
                    setZekhamat(false);

                if (productt["pe_length"] === "1")
                    setTol(true);
                else
                    setTol(false);
                if (productt["pe_width"] === "1")
                    setArz(true);
                else
                    setArz(false);
                if (productt["pe_colorcode"] === "1")
                    setTxtcolorcode(true);
                else
                    setTxtcolorcode(false);
                if (productt["pe_tiletype"] !== "") {
                    setTT(JSON.parse(productt["pe_tiletype"]));
                } else {
                    setTT(false);
                }
            })
            .catch(error => console.log(error));
    }
    const handleClick = (productId, productTitle) => {
        setNextbtn(true);
        setProductselected(productId);
        setTitleproductselected(productTitle)
    }
    const handleChange = (event) => {
        setUnit(event.target.value);
    };
    const hnadle_change_tiletype = (event) => {
        setTileType(event.target.value);
    }
    const handle_serach = (event) => {
        setSearch(event.target.value);
    }
    const handle_change_zekhamat = (event) => {
        setTxtZekhamat(toEnglishDigits(event.target.value));
    }
    const handle_change_total = (event) => {
        setTotal(toEnglishDigits(event.target.value));
    }
    const handle_change_arz = (event) => {
        setTxtArz(toEnglishDigits(event.target.value));
    }
    const handle_change_colorcode = (event) => {
        setColorcode(event.target.value);
    }
    const handle_change_tol = (event) => {
        setTxtTol(toEnglishDigits(event.target.value));
    }
    const handle_change_price = (event) => {
        let pe = toEnglishDigits(event.target.value);
        pe = pe.replace(/,/g, '');
        let nf = new Intl.NumberFormat("en-US");
        if (nf.format(pe) !== "NaN")
            setPrice(nf.format(pe));
    }
    const handlebtaddClick = () => {
        setLoading(true);
        Send_to_server();
    }

    function toEnglishDigits(str) {
        // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
        var e = '۰'.charCodeAt(0);
        str = str.replace(/[۰-۹]/g, function (t) {
            return t.charCodeAt(0) - e;
        });

        // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
        e = '٠'.charCodeAt(0);
        str = str.replace(/[٠-٩]/g, function (t) {
            return t.charCodeAt(0) - e;
        });
        return str;
    }

    return (
        <div>
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            {succsMsg !== '' ? <SuccsMsg message={succsMsg} openn={true} setsuccsmsg={setSuccsMsg} /> : '' }
            <Dialog
                open={open}
                onClose={handleClose}>
                <DialogContent dividers={'paper'}>
                    <Box sx={style}>
                        {!addbtn ?
                            <TextField
                                id="filled-basic"
                                variant="outlined"
                                placeholder="جست و جو در تمامی محصولات"
                                fullWidth
                                dir="rtl"
                                value={search}
                                autoComplete='off'
                                size="small"
                                onChange={handle_serach}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
                                }}/>
                            : titleproductselected}
                        <Divider variant="fullWidth" sx={{marginTop: 1}}/>

                        {
                            showproductlist ?
                                <Typography id="keep-mounted-modal-description"
                                            sx={{mt: 1, overflowX: 'auto', height: 350}}>
                                    <div style={{overflowX: 'auto'}}>
                                        {!loadingProduct ?
                                            <List className="productlistitem"
                                                  sx={
                                                      {
                                                          width: '100%',
                                                          maxWidth: 360,
                                                          bgcolor: 'background.paper',
                                                      }
                                                  }>
                                                {product.filter(product1 => product1.pt_title.includes(search)).map(product1 => (
                                                    <div>
                                                        <ListItemButton key={product1.pt_id}
                                                                        onClick={() => handleClick(product1.pt_id, product1.pt_title)}
                                                                        sx={{
                                                                            fontFamily: 'farsi',
                                                                            textAlign: 'center',
                                                                        }} data={product1}>
                                                            <ListItemText
                                                                primary={product1.pt_title}>
                                                            </ListItemText>
                                                        </ListItemButton>
                                                        <Divider light/>
                                                    </div>
                                                ))}
                                            </List>
                                            : <CircularProgress sx={{margin: 2}}/>}
                                    </div>
                                </Typography> :

                                <div>
                                    <TextField
                                        autoComplete='off'
                                        type='tel'
                                        fullWidth
                                        id="outlined-basic"
                                        label="تعداد"
                                        value={total}
                                        onChange={handle_change_total}
                                        variant="outlined" sx={{
                                        marginTop: 2,
                                        marginBottom: 1,
                                    }}/>
                                    {zekhamat === true ?
                                        <TextField
                                            autoComplete='off'
                                            type='tel'
                                            fullWidth
                                            id="outlined-basic"
                                            label="ضخامت (میلی متر)"
                                            variant="outlined"
                                            value={txtzekhamat}
                                            onChange={handle_change_zekhamat}
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 1,
                                            }}/>
                                        : ''}
                                    {arz === true ?
                                        <TextField
                                            autoComplete='off'
                                            type='tel'
                                            fullWidth
                                            id="outlined-basic"
                                            label="عرض (میلی متر)"
                                            value={txtarz}
                                            onChange={handle_change_arz}
                                            variant="outlined"
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 1,
                                            }}/>
                                        : ''}
                                    {tol === true ?
                                        <TextField
                                            autoComplete='off'
                                            type='tel'
                                            fullWidth
                                            id="outlined-basic"
                                            label="طول (سانتی متر)"
                                            variant="outlined"
                                            value={txttol}
                                            onChange={handle_change_tol}
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 1,
                                            }}/>
                                        : ''}
                                    {tT ?
                                        <FormControl fullWidth>
                                            <InputLabel
                                                sx={{marginTop: 1, direction: "rtl"}}>
                                                نوع تایل
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"

                                                onChange={hnadle_change_tiletype}
                                                sx={{marginBottom: 2, marginTop: 2, direction: "rtl"}}>
                                                {
                                                    tT.map(item => (
                                                        <MenuItem value={item.title}>{item.title}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                        : ''}
                                    {txtcolorcode === true ?
                                        <TextField
                                            autoComplete='off'
                                            type='text'
                                            fullWidth
                                            id="outlined-basic"
                                            label="کد رنگ"
                                            value={colorcode}
                                            onChange={handle_change_colorcode}
                                            variant="outlined"
                                            sx={{
                                                marginTop: 1,
                                                marginBottom: 1,
                                            }}/>
                                        : ''}
                                    <TextField
                                        autoComplete='off'
                                        type='tel'
                                        fullWidth
                                        id="outlined-basic"
                                        label="قیمت"
                                        variant="outlined"
                                        value={price}
                                        onChange={handle_change_price}
                                        sx={{
                                            marginBottom: 1,
                                        }}/>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">واحد</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={unit}
                                            label="Unit"
                                            onChange={handleChange}
                                            sx={{marginBottom: 3, marginTop: 1,}
                                            }>
                                            <MenuItem selected value={'مترمربع'}>مترمربع</MenuItem>
                                            <MenuItem value={'مترطول'}>مترطول</MenuItem>
                                            <MenuItem value={'شاخه'}>شاخه</MenuItem>
                                            <MenuItem value={'لیتر'}>لیتر</MenuItem>
                                            <MenuItem value={'سرویس'}>سرویس</MenuItem>
                                            <MenuItem value={'عدد'}>عدد</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                        }
                        <div style={{textAlign: "left",}}>

                            {nextbtn ?
                                <div style={{position: 'relative'}}>
                                    <Button
                                        fullWidth
                                        disabled={loading}
                                        onClick={HandlebtnnextClick}
                                        variant="contained">بعدی</Button>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </div>
                                : ''}

                            {addbtn ?
                                <div style={{position: 'relative'}}>
                                    <Button
                                        fullWidth
                                        onClick={handlebtaddClick}
                                        disabled={loading}
                                        variant="contained">افزودن به پیش فاکتور</Button>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </div>
                                : ''}
                        </div>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}
export default Addgoods;